<template>
  <div class="panel-body">
    <span class="text-size-20">作成した納品依頼を確認していただくことができます</span>
    <div id="delivery-status-inquiry" class="flexbox gap-15 flex-content-start" style="flex-wrap: nowrap;">
      <div class="filter">
        <form autocomplete="off"  class="w-210">
          <div class="form-group">
            <label class="control-label label-normal">納品管理番号</label>
            <input type="text" class="form-control" v-model.trim="filter.deliveryNo" @keydown.enter="filterDelivery">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">ASIN</label>
            <input type="text" class="form-control" v-model.trim="filter.asin" @keydown.enter="filterDelivery">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">納品予定日</label>
            <date-picker
              v-model="filter.deliveryDate"
              placeholder=""
              ref="datepickerStart"
              format="YYYY/MM/DD"
              :input-attr="{id: 'delivery-date'}"
              :lang="lang"
              :append-to-body="false"
              :popup-style="{ top: '100%' }"
            ></date-picker>
          </div>
          <div class="form-group">
            <label class="control-label label-normal">SKU</label>
            <input type="text" class="form-control" v-model.trim="filter.sku" @keydown.enter="filterDelivery">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">商品ラベル</label>
            <input type="text" class="form-control" v-model.trim="filter.goodsLabel" @keydown.enter="filterDelivery">
          </div>
          <span class="control-label label-normal">表示</span><br>
          <div class="pd-l-10 pd-t-10">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="show-delete-item-ckb"
                v-model="filter.isShowDelete">
              <label class="form-check-label" for="show-delete-item-ckb">削除明細を表示する</label>
            </div>
          </div>
          <div class="flexbox gap-10 mr-t-10">
            <button type="button" class="btn btn-primary w-100" @click="filterDelivery">検索</button>
            <button type="button" class="btn w-100" @click="clearFilter">クリア</button>
          </div>
        </form>
      </div>
      <div class="">
        <div class="flexbox justify-between">
          <span class="count">{{ pageData.length }} 件</span>
          <pagination
            :totalPage="totalPage"
            :currentPage="currentPage"
            :paginationStorageKey="paginationStorageKey"
            @updateCurrentPage="updateCurrentPage"
          />
        </div>
        <div class="table-outter">
          <div class="table-header">
            <tr>
              <th class="w-110"></th>
              <th class="text-left w-160">区分</th>
              <th class="text-left w-200">納品管理番号</th>
              <th class="text-left w-250">納品名</th>
              <th class="text-center w-150">
                入荷状況
                <br>
                (実績数/予定数)
              </th>
              <th class="text-left w-110">納品予定日</th>
              <th class="text-left w-110">員数検品</th>
              <th class="text-left w-150">発送情報登録</th>
              <th class="w-125"></th>
            </tr>
          </div>
          <div v-if="displayData.length > 0" v-for="(item, index) in displayData" :key="index"
            class="table-group mr-t-10" :class="{ 'deleted': item.isDeleted }"
            :id="'table-group-' + item.deliveryNo">
            <table style="table-layout: fixed;">
              <tbody>
                <tr>
                  <td class="text-center">
                    <button class="btn btn-expand w-100" data-toggle="collapse" :id="'btn-expand-' + item.deliveryNo" :data-target="'#' + item.deliveryNo" @click="handleExpand(item.deliveryNo)" :disabled="item.boxes.length === 0">
                      <i class="fa fa-plus" aria-hidden="true"></i> 開く
                    </button>
                    <button class="btn btn-collapse w-100 hidden" data-toggle="collapse" :id="'btn-collapse-' + item.deliveryNo" :data-target="'#' + item.deliveryNo" @click="handleCollapse(item.deliveryNo)">
                      <i class="fa fa-minus" aria-hidden="true"></i> 閉じる
                    </button>
                  </td>
                  <td class="text-left w-160">
                    <div>直接納品</div>
                  </td>
                  <td class="text-left w-200">
                    <div>{{ item.deliveryNo }}</div>
                  </td>
                  <td class="text-left w-250" style="word-break: break-all;">
                    <div>{{ item.deliveryName }}</div>
                  </td>
                  <td class="text-right w-150">
                    <div class="font-bold text-gray-2" style="display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 10px;">
                      ({{ formatNumber(item.totalQtyPO) }} / {{ formatNumber(item.totalQuantity) }})
                      <div class="delivery-status" :class="getDeliveryStatusClass(item.status)"></div>
                    </div>
                  </td>
                  <td class="text-left w-110">
                    <div class="w-100">{{ formatDate(item.deliveryDate) }}</div>
                  </td>
                  <td class="text-left w-110">
                    <div class="w-100">{{ item.inventoryCheck }}</div>
                  </td>
                  <td class="text-left w-150">
                    <div class="w-140">
                      <shipping-info
                        :key="`info-bubble-${item.deliveryNo}`"
                        :delivery="item"
                        :activeDeliveryNo="activeDeliveryNo"
                        @deliveryInfoRegister="deliveryInfoRegister"
                        @updateActiveDeliveryNo="updateActiveDeliveryNo"
                      />
                    </div>
                  </td>
                  <td class="text-left w-125">
                    <div class="btn-group">
                      <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                        操作
                        <span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu" role="menu" @click.stop>
                        <li @click="openConfirmCoppyModal(item)">複製する</li>
                        <li :class="item.disableDelete ? 'disabled' : ''" :disabled="item.disableDelete" @click="openConfirmDeleteDeliveryModal(item)">削除する</li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="item.boxes.length" :id="item.deliveryNo" class="collapse " style="background-color: #fff; margin: 0 10px 10px 10px;">
              <div v-for="box in item.boxes" :key="box.packingID" class="delivery-box">
                <div class="box-header">
                  <div>輸送箱{{ box.boxNo }}</div>
                  <div>梱包ID：{{ box.packingID }}</div>
                  <div>
                    <button class="btn btn-warning" @click="openPackingLabel(item.deliveryNo, box.packingID)">外装ラベルを出力</button>
                  </div>
                </div>
                <tr>
                  <td colspan="8" class="table-item">
                    <table style="width: 100%; table-layout: fixed;">
                      <thead>
                        <tr>
                          <th class="text-center w-95">納品する商品</th>
                          <th style="min-width: 500px;"></th>
                          <th class="text-center w-150">入荷状況</th>
                          <th class="w-200 pd-l-20">商品ラベル</th>
                          <th class="text-right w-120">有効期限</th>
                          <th class="w-200 text-right">入荷ID</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="product in box.items" :key="product.itemId">
                          <td class="text-center">
                              <div v-if="product.productImage" class="box-selected-product-image w-50">
                                  <img loading="lazy" :src="product.productImage"
                                      alt="" class="selected-product-image img-responsive">
                              </div>
                              <div v-if="product.judgmentStatusStr" class="box-delivery-judgment-status" :class="getJudgmentStatusClass(product.judgmentStatusStr)">{{ product.judgmentStatusStr }}</div>
                          </td>
                          <td class="text-left">
                            <span>{{ product.itemName }}</span>
                            <br>
                            <span><b>ASIN：</b>{{ product.asin }} / <b>SKU：</b>{{ product.sku }}</span>
                            <br>
                            <span><b>商品ID：</b>{{ product.itemId }}</span>
                          </td>
                          <td>
                            <div class="font-bold text-gray-2" style="display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 10px;">
                              <span>{{ product.status }}({{ formatNumber(product.qtyPO) }} / {{ formatNumber(product.quantity) }})</span>
                              <div class="delivery-status" :class="getDeliveryStatusClass(product.status)"></div>
                            </div>
                          </td>
                          <td class="pd-l-20">
                            <div>
                              {{ product.fnsku }}
                            </div>
                          </td>
                          <td class="text-right" :class="product.expirationDate ? '' : 'text-gray'">
                            {{ product.expirationDate ? formatDate(product.expirationDate) : 'なし'}}
                          </td>
                          <td class="text-right">
                            {{ product.itemPONo }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </div>
            </div>
          </div>
          <div v-if="displayData.length === 0" class="no-data">
              データが見つかりません。
          </div>
        </div>
      </div>
    </div>
    <modal-confirm-delete
      v-if="openModalConfirmDeleteDelivery"
      @confirm="handleDelete()"
      @close="closeConfirmDeleteDeliveryModal()"
    />
    <modal-confirm
      v-if="openModalConfirmCoppyDelivery"
      :message="confirmCoppyMessage"
      @confirm="handleCoppy()"
      @close="closeConfirmCoppyModal()"
    />
  </div>
</template>

<script>
import Util from '@/common/utility'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import WarehouseScService from '@/services/warehousescservice'
import ShippingInfo from '@/view/warehouseAcross/components/ShippingInfo'
import ModalConfirmDelete from '@/components/ModalDeleteAlert'
import ModalConfirm from '@/components/ModalConfirm'
import Pagination from '@/components/PaginationNextPage'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    DatePicker,
    ShippingInfo,
    ModalConfirmDelete,
    ModalConfirm,
    Pagination
  },
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconUrls () {
      return this.$store.getters.getWareHouseIcons
    },
    amazonIcon () {
      return this.iconUrls['Amazon']
    },
    paginationStorageKey () {
      return 'scDeliveryList'
    },
    maxRows () {
      return this.$store.getters.getPaginationRow(this.paginationStorageKey)
    }
  },
  data () {
    return {
      filter: {
        deliveryNo: '',
        asin: '',
        sku: '',
        goodsLabel: '',
        deliveryDate: '',
        isShowDelete: false
      },
      lang: {
        days: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        pickers: ['1週間後', '1ヶ月後', '1週間前', '1ヶ月前'],
        placeholder: {
          date: '日付を選択',
          dateRange: '期間を選択'
        }
      },
      defaultData: [],
      pageData: [],
      displayData: [],
      openModalConfirmDeleteDelivery: false,
      openModalConfirmCoppyDelivery: false,
      selectedItem: {},
      activeDeliveryNo: null,
      confirmCoppyMessage: `納品情報を複製します。 <br>
                            よろしければOKボタンを選択してください。 <br>
                            OKボタン選択後は、納品プラン作成画面に遷移します。`,
      totalPage: 1,
      currentPage: 1
    }
  },
  created () {
    this.getDeliveryList()
  },
  methods: {
    async getDeliveryList () {
      this.loader = this.$loading.show()
      await WarehouseScService.getDeliveryList()
        .then((response) => {
          this.defaultData = response.data
          this.pageData = this.defaultData.filter(item => {
            return item.isDeleted === this.filter.isShowDelete
          })
          this.sliceDisplayData()
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    sliceDisplayData () {
      setTimeout(() => {
        this.totalPage = Math.ceil(this.pageData.length / this.maxRows)
        if (this.totalPage > 0 && this.currentPage > this.totalPage) {
          this.currentPage = 1
        }
        this.displayData = this.pageData.slice((this.currentPage - 1) * this.maxRows, this.currentPage * this.maxRows)
        this.loader && this.loader.hide()
      }, 300)
    },
    handleCoppy () {
      this.closeConfirmCoppyModal()

      let logParams = {
        name: eventCode.warehouse_sc.delivery_tab.list.click_coppy_btn,
        properties: {
          deliveryNo: this.selectedItem.deliveryNo
        }
      }
      EventService.postTrackLog(logParams)

      this.$router.push({
        name: 'Warehouse sc',
        params: {
          tab: 'delivery',
          subTab: 'direct-delivery'
        },
        query: {
          deliveryNo: this.selectedItem.deliveryNo
        }
      })
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD') : ''
    },
    handleExpand (id) {
      $('#table-group-' + id).addClass('expand')
      $('#btn-expand-' + id).addClass('hidden')
      $('#btn-collapse-' + id).removeClass('hidden')
    },
    handleCollapse (id) {
      $('#table-group-' + id).removeClass('expand')
      $('#btn-expand-' + id).removeClass('hidden')
      $('#btn-collapse-' + id).addClass('hidden')
    },
    openConfirmDeleteDeliveryModal (item) {
      if (item.disableDelete) {
        return false
      }
      this.selectedItem = item
      this.openModalConfirmDeleteDelivery = true
    },
    closeConfirmDeleteDeliveryModal () {
      this.openModalConfirmDeleteDelivery = false
      $('#delete-alert').modal('hide')
    },
    openConfirmCoppyModal (item) {
      this.selectedItem = item
      this.openModalConfirmCoppyDelivery = true
    },
    closeConfirmCoppyModal () {
      $('#confirm-alert').modal('hide')
      this.openModalConfirmCoppyDelivery = false
    },
    filterDelivery (isWriteLog = true) {
      if (isWriteLog) {
        let logParams = {
          name: eventCode.warehouse_sc.delivery_tab.list.click_search_btn,
          properties: {...this.filter}
        }
        EventService.postTrackLog(logParams)
      }

      this.loader = this.$loading.show()

      setTimeout(() => {
        const {
          deliveryNo,
          asin,
          sku,
          goodsLabel,
          deliveryDate,
          isShowDelete
        } = this.filter

        const lower = str => str.toLowerCase()
        const matchIncludes = (target, keyword) => lower(target || '').includes(lower(keyword || ''))

        this.pageData = this.defaultData.filter(item => {
          if (!isShowDelete && item.isDeleted) return false

          if (deliveryNo && !matchIncludes(item.deliveryNo, deliveryNo)) return false

          if (asin && !item.boxes.some(b => b.items.some(i => matchIncludes(i.asin, asin)))) return false
          if (sku && !item.boxes.some(b => b.items.some(i => matchIncludes(i.sku, sku)))) return false
          if (goodsLabel && !item.boxes.some(b => b.items.some(i => matchIncludes(i.fnsku, goodsLabel)))) return false

          if (deliveryDate && this.formatDate(item.deliveryDate) !== this.formatDate(deliveryDate)) return false

          return true
        })
        this.sliceDisplayData()
      }, 500)
    },
    clearFilter () {
      this.filter = {
        deliveryNo: '',
        asin: '',
        sku: '',
        goodsLabel: '',
        deliveryDate: '',
        isShowDelete: false
      }
      this.filterDelivery(false)
    },
    getDeliveryStatusClass (status) {
      switch (status) {
        case '入荷待ち':
          return 'wait-for-delivery'
        case '入荷済み':
          return 'in-stock'
        default:
          return 'received'
      }
    },
    getJudgmentStatusClass (status) {
      let statusStop = ['停止中', '削除済']
      let statusSuccess = ['出品中']
      let statusWarning = ['未審査', '審査中']
      let statusDanger = ['出品NG', '審査NG']
      if (!status) {
        return ''
      }
      if (statusSuccess.includes(status)) {
        return 'judgment-status-success'
      }
      if (statusWarning.includes(status)) {
        return 'judgment-status-warning'
      }
      if (statusDanger.includes(status)) {
        return 'judgment-status-danger'
      }
      if (statusStop.includes(status)) {
        return 'judgment-status-stop'
      }
    },
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    updateActiveDeliveryNo (deliveryNo) {
      this.activeDeliveryNo = this.activeDeliveryNo === deliveryNo ? null : deliveryNo
    },
    handleDelete () {
      this.closeConfirmDeleteDeliveryModal()
      if (this.selectedItem.disableDelete) {
        return false
      }

      let logParams = {
        name: eventCode.warehouse_sc.delivery_tab.list.click_delete_btn,
        properties: {
          deliveryNo: this.selectedItem.deliveryNo
        }
      }
      EventService.postTrackLog(logParams)

      this.deleteDirectDelivery()
    },
    async deleteDirectDelivery () {
      this.loader = this.$loading.show()
      let params = {
        deliveryNo: this.selectedItem.deliveryNo
      }
      await WarehouseScService.deleteDirectDelivery(params)
        .then((response) => {
          if (response.data.deliveryNo) {
            this.defaultData = this.defaultData.map(item => {
              if (item.deliveryNo === response.data.deliveryNo) {
                return {
                  ...item,
                  status: '削除済',
                  isDeleted: true,
                  disableDelete: true
                }
              }
              return item
            })
            this.pageData = this.pageData.filter(item => {
              if (item.deliveryNo === response.data.deliveryNo) {
                item.status = '削除済'
                item.isDeleted = true
                item.disableDelete = true
              }
              if (!this.filter.isShowDelete && item.isDeleted) return false
              return true
            })
            this.sliceDisplayData()

            this.$store.commit('toggleModal', {
              show: true,
              message: '納品依頼を削除しました。'
            })
          }
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    openPackingLabel (deliveryNo, packingID) {
      let logParams = {
        name: eventCode.warehouse_sc.delivery_tab.list.click_delivery_label_print_btn,
        properties: {
          deliveryNo: deliveryNo,
          packingID: packingID
        }
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show()
      WarehouseScService.downloadPackingLabel({ deliveryNo: deliveryNo, packingID: packingID }, `梱包ラベル_${packingID}.pdf`)
        .catch(error => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    deliveryInfoRegister (deliveryNo, input) {
      if (!input) {
        return
      }

      let logParams = {
        name: eventCode.warehouse_sc.delivery_tab.list.click_regis_shipping_info_btn,
        properties: {
          deliveryNo: deliveryNo,
          input: input
        }
      }
      EventService.postTrackLog(logParams)
      this.loader = this.$loading.show()
      let params = {
        deliveryNo: deliveryNo,
        shippingInfo: input
      }
      WarehouseScService.updateShippingInfo(params)
        .then((response) => {
          this.updateActiveDeliveryNo(null)
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    handleClickOutside (event) {
      if (this.activeDeliveryNo) {
        const activePopup = document.querySelector(`.delivery-info-${this.activeDeliveryNo}`)
        if (activePopup && !activePopup.contains(event.target)) {
          this.activeDeliveryNo = null
        }
      }
    },
    updateCurrentPage (val) {
      this.loader = this.$loading.show()
      this.currentPage = val
      this.sliceDisplayData()
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.warehouse_sc.delivery_tab.list.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
    window.addEventListener('click', this.handleClickOutside)
  },
  watch: {
    maxRows () {
      this.loader = this.$loading.show()
      this.sliceDisplayData()
    }
  },
  beforeDestroy () {
    window.removeEventListener('click', this.handleClickOutside)
  }
}
</script>
<style scoped>
#delivery-status-inquiry {
  overflow-y: auto;
}
.judgment-status-stop {
  background-color: #a6a6a6;
  color: #f2f2f2;
}
.judgment-status-danger {
  background-color: #c00000;
  color: #fff;
}
.panel-body {
  padding: 10px 0;
}
.control-label {
  color: #595959;
}
.filter {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ccc;
  height: auto;
  box-sizing: content-box;
}
.form-check-label {
  padding-left: 5px;
  font-weight: unset;
}
.table-outter {
  margin-top: 5px;
  width: 1470px;
  overflow: hidden;
  padding-bottom: 120px;
}
.table-header {
  border: 1px solid #ccc;
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 1;
  background: #deebf7;
}
.table-header th {
  padding: 5px;
  margin: 0 10px;
  color: #595959;
  background: #deebf7;
}
.btn.text-danger {
  font-weight: unset;
}
.btn.disabled {
  background-color: #efefef;
  color: #000;
  border: 1px solid #ccc;
}
.table-item th{
  background-color: #fff;
  color: #000;
  font-weight: bold;
  border: none;
  border-bottom: 2px solid #008cc6;
  z-index: -1;
}
.table-item td {
  border-bottom: 1px solid #ccc;
}
.table-group {
  background-color: #fff;
  border: 1px solid #ccc;
  vertical-align: middle;
}
.table-group td {
  padding: 5px;
  height: 50px;
}
.table-group > tr.collapse td {
  background-color: red;
}
.table-group.expand {
  background-color: #deebf7;
}
.table-group.deleted {
  background-color: #ccc;
}
.btn-expand {
  color: #008cc6;
  border: 1px solid #008cc6;
  background-color: #fff;
}
.btn-collapse {
  color: #000;
  background-color: #bfbfbf;
  border: 1px solid #ccc;
}
.box-selected-product-image {
  margin: 0 auto;
}
.delivery-status {
  width: 80px;
  height: 10px;
  border-radius: 4px;
  border: 1px solid #bfbfbf;
}
.delivery-status.wait-for-delivery {
  background-color: #f2f2f2;
}
.delivery-status.received {
  background-color: #ffd428;
}
.delivery-status.in-stock {
  background-color: #70ad47;
}
.delivery-box {
  margin-bottom: 10px;
  padding: 10px;
}
.box-header {
  display: flex;
  gap: 15px;
  align-items: center;
  padding: 5px 10px;
  background-color: #0070c0;
  color: #fff;
}
.no-data {
  text-align: center;
  color: red;
  font-weight: bold;
  background-color: rgb(242, 222, 222);
}
.pd-l-20 {
  padding-left: 20px !important;
}
.text-primary {
  color:#2E75B6;
}
.w-210 {
  width: 210px !important;
}
.mx-datepicker {
  width: 100%;
}
.dropdown-menu {
  min-width: 100px;
  max-width: 110px;
  padding: unset;
  left: 0 !important;
  font-size: 14px;
}
.dropdown-menu li {
  height: 30px;
  padding: 3px 5px;
  line-height: 24px;
}
.dropdown-menu li:hover {
  cursor: default;
  background-color: #deebf7;
}
.dropdown-menu > li > a {
  padding: unset;
}
.dropdown-menu > li.disabled {
  color: #bfbfbf;
  pointer-events: none;
}

.text-gray-2 {
  color: #595959;
}
@media (max-width: 1920px) {
  .table-outter {
    width: 1440px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/DeliveryStatusInquiry.vue